import React from 'react'
import { Container } from 'react-bootstrap'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Tilt from 'react-tilt'
import './experiencecomp.css'
import Card from 'react-bootstrap/Card'

const Experience = () => {
    return (
        <div id='experience'>
            <h1 className="pt-3 text-center font-details-b pb-3">EXPERIENCE</h1>
            <Jumbotron className="jumbo-style">
                <Container>
                    <Tilt options={{max:25}}>
                        <Card>
                            <Card.Body className="d-flex justify-content-center flex-column">
                                <div>
                                <Card.Title className="text-center">Software Engineer</Card.Title>
                                </div>
                                <div>
                                <Card.Text className="text-center style">
                                    <strong className="body-title-style ">Full Stack Developer</strong>
                                    <br />
                                    <strong>Technology:</strong> React JS, NodeJs, Wordpress, MongoDb,SQL,AWS, Python,Power BI, Data Science
                                    <br />
                                    <strong>Duration:</strong> August 2019 - Present
                                    <br/>
                                    <strong> Description </strong>
                                    <ul className="text-left">
                                        <li><strong>Developed &amp; enhanced</strong> multiple features with customizability option across web application.</li>
                                        <li><strong>Developed</strong> Wordpress Plugin for Filteration Via Feet &amp; Inches and have developer multiple Product pages
                                        that increased traffic by 60%
                                        </li>
                                        <li><strong>Provided</strong> application maintenance  
                                        </li>
                                        <li><strong>Performed</strong> CRUD operations on multiple databases to load/ remove data according 
                                        to the business requirements.</li>
                                    </ul>
                                </Card.Text>
                                </div>
                            </Card.Body>
                        </Card>
                    </Tilt>
                </Container>
            </Jumbotron>
        </div>
    )
}

export default Experience 
